import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { utils, i18next, anodum } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import fieldNames from '../constants/field-names';

const { ControlGroup, FieldStatus, CodeEditorField } = designSystem;

function extractIframeHtml(html) {
  const doc = anodum.parseDocumentFromString(html);
  const iframe = doc.body.querySelector('iframe');

  return iframe ? iframe.outerHTML : null;
}

const CodeForm = ({ control }) => {
  const [errorMessage, setErrorMessage] = useState(null);

  const onCodePaste = (pasteAction) => {
    const iframeHtml = extractIframeHtml(pasteAction.text);

    if (iframeHtml) {
      // eslint-disable-next-line no-param-reassign
      pasteAction.text = iframeHtml;
    }
  };

  const onCodeError = (error) => {
    setErrorMessage(error);
  };

  const validateCode = (code) => {
    if (errorMessage) {
      return errorMessage;
    }

    if (!code) {
      return i18next.t('Invalid embed code. The empty embed code is not allowed.');
    }

    const doc = anodum.parseDocumentFromString(code);

    const containsIframesOnly = [...doc.body.childNodes].every(
      (node) => anodum.isElementNode(node) && anodum.isTag(node, 'iframe')
    );

    if (!containsIframesOnly) {
      return i18next.t('Invalid embed code. Any non-iframe html is not allowed.');
    }

    const iframes = doc.querySelectorAll('iframe');

    if (iframes.length > 1) {
      return i18next.t('Invalid embed code. Multiple iframe tags are not allowed.');
    }

    const [iframe] = iframes;
    const iframeSrc = iframe.getAttribute('src');

    if (!iframeSrc || !utils.validation.isURL(iframeSrc)) {
      return i18next.t('Invalid embed code. Iframe source is not specified.');
    }

    return null;
  };

  return (
    <React.Fragment>
      <ControlGroup title={i18next.t('Embed Code')}>
        <CodeEditorField
          control={control}
          name={fieldNames.EMBED_CODE}
          rules={{
            validate: validateCode,
          }}
          onPaste={onCodePaste}
          onEditorError={onCodeError}
        />
      </ControlGroup>
      <FieldStatus
        text={i18next.t(
          'Paste the code of your third-party content here. To embed your content via URL, select Embed URL.'
        )}
      />
    </React.Fragment>
  );
};

CodeForm.propTypes = {
  control: PropTypes.shape({}).isRequired,
};

export default CodeForm;
